import { RouteRecordRaw } from 'vue-router'

export const userRoute: Array<RouteRecordRaw> = [
    // 我的
    {
        path: '/home',
        name: 'UserHome',
        component: () => import('@/views/user/index.vue'),
        meta: { title: '我的' },
    },
    /**
     * 我的预约
     **/
    {
        path: '/booked',
        name: 'UserBooked',
        component: () => import('@/views/booked/index.vue'),
        meta: { title: '我的预约' },
    },
    /**
     * 报告单
     **/
    {
        path: '/my_report',
        name: 'UserReport',
        component: () => import('@/views/report/index.vue'),
        meta: { title: '报告单' },
    },
    {
        path: '/check_report',
        name: 'UserReportDetail',
        component: () => import('@/views/report/detail.vue'),
        meta: { title: '报告单详情', share: true },
    },
    /**
     * 电子病历
     **/
    {
        path: '/useMem/case',
        component: () => { },
        beforeEnter: (to, from, next) => {
            let { brandId, uid } = to.query
            if (brandId && uid) {
                next(`/user/${uid}/case?brandId=${brandId}`)
            }
        },
        meta: { title: '电子病历' },
    },
    {
        path: '/useMem/:uid/case',
        name: 'Case',
        component: () => import('@/views/medicalRecord/index.vue'),
        meta: { title: '电子病历' },
    },
    // {
    //     path: '/useMem/:uid/case/:cid',
    //     name: 'CaseInfo',
    //     component: () => import('@/views/medicalRecord/detail.vue'),
    //     meta: { title: '查看病历详情', share: true },
    // },
    {
        path: '/useMem/case/:cid',
        name: 'CaseInfo',
        component: () => import('@/views/medicalRecord/detail.vue'),
        meta: { title: '查看病历详情', share: true },
    },
    {
        path: '/useMem/:uid/history',
        name: 'History',
        component: () => import('@/views/medicalRecord/history.vue'),
        meta: { title: '病史信息' },
    },
    {
        path: '/useMem/:uid/historyPhysique',
        name: 'HistoryPhysique',
        component: () => import('@/views/medicalRecord/physique.vue'),
        meta: { title: '趋势图' },
    },
    {
        path: '/useMem/:uid/addPhysique',
        name: 'AddPhysique',
        component: () => import('@/views/medicalRecord/addPhysique.vue'),
        meta: { title: '趋势图' },
    },
    // 会员订单
    {
        path: '/order/:uid',
        name: 'UserOrderList',
        component: () => import('@/views/order/index.vue'),
        meta: { title: '我的订单' },
    },
    {
        path: '/order/detail_list',
        name: 'UserOrderDetail',
        component: () => import('@/views/order/detail.vue'),
        meta: { title: '订单详情' },
    },
    // 订单支付
    {
        path: '/order/pay',
        name: 'UserOrderPay',
        component: () => import('@/views/order/pay.vue'),
        meta: { title: '支付' },
    },
    // 会员账户
    {
        path: '/member/:userId',
        name: 'UserAccount',
        component: () => import('@/views/account/index.vue'),
        meta: { title: '我的账户' },
    },
    {
        path: '/member/:userId/detail/:accountId',
        name: 'UserAccountDetail',
        component: () => import('@/views/account/detail.vue'),
        meta: { title: '账户明细' },
    },
    {
        path: '/member/:userId/integral/:accountId',
        name: 'UserAccountIntegral',
        component: () => import('@/views/account/integral.vue'),
        meta: { title: '积分明细' },
    },
    {
        path: '/member/interest/:levelId',
        name: 'UserAccountInterest',
        component: () => import('@/views/account/interest.vue'),
        meta: { title: '会员权益' },
    },
    // 充值
    {
        path: '/member/recharge/:accountId/:userId',
        name: 'UserAccountRecharge',
        component: () => import('@/views/account/recharge.vue'),
        meta: { title: '充值' },
    },
    // 我的挂账
    {
        path: '/credit',
        name: 'UserAccountCredit',
        component: () => import('@/views/account/credit.vue'),
        meta: { title: '我的挂账' },
    },
    // 地址管理
    {
        path: '/delivery/address',
        name: 'AddressList',
        component: () => import('@/views/delivery/address.vue'),
        meta: { title: '地址管理' },
    },
    {
        path: '/delivery/address/:addressId',
        name: 'AddressEdit',
        component: () => import('@/views/delivery/info.vue'),
        meta: { title: '编辑地址' },
    },
    {
        path: '/delivery/address/add',
        name: 'AddressAdd',
        component: () => import('@/views/delivery/info.vue'),
        meta: { title: '添加地址' },
    },
    /**
     * 次卡
     */
    // 次卡消费
    {
        path: '/placeCard',
        name: 'UserPlaceCard',
        component: () => import('@/views/account/placeCard/index.vue'),
        meta: { title: '次卡消费' },
    },
    // 次卡消费详情
    {
        path: '/cardDetails',
        name: 'UserPlaceCardDetails',
        component: () => import('@/views/account/placeCard/cardDetails.vue'),
        meta: { title: '次卡消费' },
    },


    // 我的评价
    {
        path: '/evaluation',
        name: 'UserEvaluation',
        component: () => import('@/views/evaluation/index.vue'),
        meta: { title: '我的评价' },
    },
    // 我的评价-写评价
    {
        path: '/evaluation/writeReview',
        name: 'UserWriteReview',
        component: () => import('@/views/evaluation/writeReview.vue'),
        meta: { title: '写评价' },
    },
    // 我的评价-我的评价
    {
        path: '/evaluation/myReview',
        name: 'UserMyReview',
        component: () => import('@/views/evaluation/myReview.vue'),
        meta: { title: '我的评价' },
    },
]
